import React from 'react';
import { useFormContext } from 'react-hook-form';
import { SendApplicationFormValues } from '../../types';
import Grid from '@mui/material/Grid2';
import { CurrencyInputField, InputField, NumberFormatField, SelectField } from 'components/form';
import { equipmentConditions, equipmentYears } from 'modules/equipment';

export const EquipmentSection = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SendApplicationFormValues>();

  return (
    <Grid container spacing={2} pt={'12px'}>
      <Grid size={{ xs: 12, md: 3 }}>
        <InputField
          label="Stock #"
          control={control}
          name="equipment.stockNumber"
          inputProps={{ variant: 'outlined' }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <CurrencyInputField
          control={control}
          label="Amount Requested"
          name="equipment.amountRequested"
          textFieldProps={{ variant: 'outlined' }}
        />
      </Grid>
      <Grid container spacing={2} size={{ xs: 12, md: 3 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <NumberFormatField
            control={control}
            label="Quantity"
            name="equipment.quantity"
            textFieldProps={{ size: 'small', fullWidth: true, variant: 'outlined' }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SelectField
            control={control}
            label="Year"
            name="equipment.year"
            options={equipmentYears}
            variant="outlined"
          />
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <SelectField
          control={control}
          label="Condition"
          name="equipment.condition"
          options={equipmentConditions}
          variant="outlined"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <InputField
          label="Serial/VIN#"
          control={control}
          name="equipment.serialVin"
          inputProps={{ variant: 'outlined' }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <InputField label="Make" control={control} name="equipment.make" inputProps={{ variant: 'outlined' }} />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <InputField label="Model" control={control} name="equipment.model" inputProps={{ variant: 'outlined' }} />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <NumberFormatField
          control={control}
          label="Mileage"
          name="equipment.mileage"
          textFieldProps={{ size: 'small', fullWidth: true, variant: 'outlined' }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <InputField
          label="Description"
          control={control}
          name="equipment.description"
          inputProps={{ variant: 'outlined' }}
        />
      </Grid>
    </Grid>
  );
};
